import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Package } from 'lucide-react';

const AddOnsPanel = ({ addOns, totalAddOnItems }) => {
  if (!addOns || addOns.length === 0) return null;

  return (
    <Card className="border border-gray-200 shadow-sm">
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-semibold text-gray-800 flex items-center gap-2">
          <Package className="h-5 w-5 text-blue-500" />
          Add-Ons
          <span className="ml-auto text-sm font-normal text-gray-500">{totalAddOnItems} total</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid gap-3 grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {addOns.map((addon) => (
            <div
              key={addon.name}
              className="flex items-center justify-between p-3 rounded-lg bg-blue-50 border border-blue-100"
            >
              <span className="text-sm font-medium text-gray-700 truncate mr-2">{addon.name}</span>
              <span className="text-lg font-bold text-blue-600 shrink-0">{addon.count}</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default AddOnsPanel;
